import Dropdown from 'lib/components/Dropdown/Dropdown'
import FilterDropdownTrigger from 'lib/components/FilterDropdownTrigger/FilterDropdownTrigger'
import { buildQueryString, QUERY_KEYS, QUERY_VALUES } from 'lib/util/routing'
import StartTime, { getDisplayNames } from 'pages/Home/StartTime'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

export interface StartTimeDropdownProps extends RouteComponentProps {
  selectedStartTime: StartTime
}

export default withRouter(function StartTimeDropdown(props: StartTimeDropdownProps) {
  const { location, selectedStartTime } = props
  const [isOpen, setIsOpen] = useState(false)
  const [t] = useTranslation()

  const openDropdown = () => setIsOpen(true)
  const closeDropdown = () => setIsOpen(false)
  const displayName = getDisplayNames(t)

  const title =
    selectedStartTime !== StartTime.All
      ? t('home.startTimes.title', { startTime: displayName[selectedStartTime] })
      : undefined

  return (
    <Dropdown>
      <FilterDropdownTrigger className="start-time-dropdown__trigger" title={title} onClick={openDropdown}>
        {displayName[selectedStartTime]}
      </FilterDropdownTrigger>
      {isOpen && (
        <Dropdown.Menu flip={true} onRequestClose={closeDropdown}>
          <Dropdown.MenuItem linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.start]]) } }}>
            {t('home.startTimes.all')}
          </Dropdown.MenuItem>
          <Dropdown.MenuItem
            linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.start, QUERY_VALUES.morning]]) } }}>
            {t('home.startTimes.morning')}
          </Dropdown.MenuItem>
          <Dropdown.MenuItem
            linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.start, QUERY_VALUES.afternoon]]) } }}>
            {t('home.startTimes.afternoon')}
          </Dropdown.MenuItem>
          <Dropdown.MenuItem
            linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.start, QUERY_VALUES.evening]]) } }}>
            {t('home.startTimes.evening')}
          </Dropdown.MenuItem>
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
})
